
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.15,"time":9000,"words":30}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Marzagalli, S., Asselin, C., Bouju, A., Charles, L., Daudin, G., Geoffroy, G., … Zoffoli, M. (2021). Commerce multi-échelles autour du port de La Rochelle au XVIIIe siècle. Repéré à `}<a parentName="p" {...{
        "href": "https://medialab.github.io/portic-storymaps-2021"
      }}>{`https://medialab.github.io/portic-storymaps-2021`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {}

